<template>
    <div class="artist-page">
        <Artist
            :key="artist.nid"
            :artist="artist"
            v-if="artist"
            :teaser="false"
        />

        <div class="filters">
            <span class="material-icons">sort</span>
            <h3>Sort By</h3>
            <div class="select-wrap">
                <select v-model="searches.sortBy">
                    <option value="">Default</option>
                    <option value="size_asc">size ⇧</option>
                    <option value="size_desc">size ⇩</option>
                    <option value="price_asc">price ⇧</option>
                    <option value="price_desc">price ⇩</option>
                    <option value="recent">most recent</option>
                </select>
            </div>
            <div class="legend">
                <span class="legend-item">
                    <span class="material-icons icon details-indicator">loupe</span>
                    click images for more info
                </span>
                <span class="legend-item">
                    <span class="material-icons icon favorite-indicator">star</span>
                    add to favorites
                    </span>
                <span class="legend-item">
                    <span class="material-icons icon availability-sold">circle</span>
                    indicates sold piece
                </span>
            </div>
        </div>
        <div class="artworks">
            <transition-group name="favorite">
                <Artwork
                    v-for="artwork in artworks"
                    :key="artwork.nid"
                    :artwork="artwork"
                    @click.capture.prevent=""
                    @click="navigate(artwork.url)"
                />
            </transition-group>
        </div>
        <transition name="modal">
            <modal v-if="selectedArtwork" @close="navigate(artist.url)">
                <template v-slot:body>
                    <Artwork
                        :key="selectedArtwork.nid"
                        :artwork="selectedArtwork"
                        :teaser="false"
                    />
                    <router-link
                        v-if="previousArtwork"
                        :to="previousArtwork.url"
                        class="prev"
                        >Prev</router-link
                    >
                    <router-link
                        v-if="nextArtwork"
                        :to="nextArtwork.url"
                        class="next"
                        >Next</router-link
                    >
                    <div style="display: none" class="preloader">
                        <img
                            :src="previousArtwork.fullImage"
                            v-if="previousArtwork"
                        />
                        <img :src="nextArtwork.fullImage" v-if="nextArtwork" />
                    </div>
                </template>
            </modal>
        </transition>
    </div>
</template>

<script>
import ArtworkHelper from "@/mixins/PageHelper.js";
import { API_URI } from "@/helpers/config";

export default {
    name: "Collection",
    mixins: [ArtworkHelper],
    props: {
        artistSlug: String,
        selectedArtworkSlug: String,
    },
    // data() {
    //     return {
    //         searches: {sortBy: "default"},
    //     }
    // },
    computed: {
        documentTitle() {
            const vm = this;
            const parts = [];
            if (vm.selectedArtwork) {
                parts.push(vm.selectedArtwork.title);
            }
            if (vm.artist) {
                const artistPart = vm.selectedArtwork
                    ? `by ${vm.artist.name}`
                    : vm.artist.name;
                parts.push(artistPart);
            }
            parts.push(vm.documentTitleBase);
            return parts.join(" | ");
        },
        ogImage() {
            const vm = this;
            var img;
            if (vm.selectedArtwork) {
                img = vm.selectedArtwork.fullImage;
            } else if (vm.artist && vm.artist.bio_image) {
                img = API_URI + "/" + vm.artist.bio_image;
            } else {
                img = require('@/assets/logo.png');
            }
            return img;
        },
        artist() {
            const vm = this;
            if (!vm.artistSlug) return;
            return vm.allArtists.find((artist) => artist.name == vm.artistSlug);
        },
        selectedArtwork() {
            const vm = this;
            const selectedId = vm.artworkSlugToId(vm.selectedArtworkSlug);
            return vm.filteredArtworks.find(
                (artwork) => +artwork.nid === selectedId
            );
        },
        filteredArtworks() {
            const vm = this;
            if (!vm.artist) return [];
            const artistUid = vm.artist.uid;
            return vm.allArtworks.filter((artwork) => artwork.uid == artistUid)
            //    .sort((a,b) => +a.sold - +b.sold);
        },
    },
};
</script>

<style lang="scss">
</style>
